import React from 'react';
import { AEInfo, AEPlanType, ChangeLabel, ParticipantDisplay, SelfText } from '../../models/annual-enrollment-models';
import { getRelationshipLabel, isPlanSelectionAvailable } from '../../helpers/annual-enrollment-helpers';
import { AnnualEnrollmentProps } from '../../../arc/models/arc-epi-props';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { AnnualEnrollmentFormValues } from '../../models/annual-enrollment-form-models';
import { ParticipantDisplayGroup } from './annual-enrollment-participants-display-group';

interface Props {
	aeInfo: AEInfo;
	initialValues: AnnualEnrollmentFormValues;
	medicalParticipants: string[];
	dentalParticipants: string[];

	annualEnrollmentProps: AnnualEnrollmentProps;
	editButton: JSX.Element;
}

export function AnnualEnrollmentParticipantsDisplay(props: Props) {
	const { aeInfo, initialValues, medicalParticipants, dentalParticipants, annualEnrollmentProps, editButton } = props;


	const getParticipantsInfo = (planType: AEPlanType): ParticipantDisplay[] => {
		const selectedParticipants = planType === AEPlanType.Medical ? medicalParticipants : dentalParticipants;

		const initialParticipants = initialValues[planType] as string[];

		// combines initial list with form values and gets unique values
		const uniqueParticipants = selectedParticipants.concat(initialParticipants).filter((p, index, arr) => arr.indexOf(p) === index);

		return uniqueParticipants.map(p => {
			let changeLabel = ChangeLabel.None;
			if (initialParticipants.includes(p) && selectedParticipants.includes(p)) {
				changeLabel = ChangeLabel.Added;
			} else if (initialParticipants.includes(p)) {
				changeLabel = ChangeLabel.Removed;
			} else {
				changeLabel = ChangeLabel.Added;
			}

			let name = annualEnrollmentProps.selfOptionText || 'Self';
			let relationshipLabel = '';
			if (p !== SelfText) {
				const match = aeInfo?.eligible_dependents?.filter(dep => dep.person?._guid === p)[0];
				name = `${match?.person?.first} ${match?.person?.middle} ${match?.person?.last} ${match?.person?.suffix}`;
				relationshipLabel = getRelationshipLabel(match?.relationship_code, annualEnrollmentProps);
			}

			return {
				name,
				relationshipLabel,
				changeLabel,
			};
		});
	};

	const medicalParticipantsDisplayInfo = getParticipantsInfo(AEPlanType.Medical);
	const dentalParticipantsDisplayInfo = getParticipantsInfo(AEPlanType.Dental);

	return (
		<DividerSection sectionText={annualEnrollmentProps?.participantSelectionLabel} secondarySectionNode={editButton}>

			{

				isPlanSelectionAvailable(aeInfo?.offerings?.M?.plans) &&
				<ParticipantDisplayGroup
					items={medicalParticipantsDisplayInfo}
					label={annualEnrollmentProps?.medicalCoverageLabel}
					annualEnrollmentProps={annualEnrollmentProps}
				/>
			}
			{

				isPlanSelectionAvailable(aeInfo?.offerings?.D?.plans) &&
				<ParticipantDisplayGroup
					items={dentalParticipantsDisplayInfo}
					label={annualEnrollmentProps?.dentalCoverageLabel}
					annualEnrollmentProps={annualEnrollmentProps}
				/>
			}


		</DividerSection>
	);
}